<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.9 13L21 13L21 11L8.9 11L1 11C1 13 1.42083 13.6875 2.2625 14.2125C3.10417 14.7375 4.05 15 5.1 15C5.88333 15 6.62917 14.8417 7.3375 14.525C8.04583 14.2083 8.56667 13.7 8.9 13Z" fill="currentColor"/>
    <rect x="1" y="7" width="3" height="3" fill="currentColor"/>
    <rect x="3" y="3" width="3" height="3" fill="currentColor"/>
    <rect x="5" y="7" width="3" height="3" fill="currentColor"/>
    </svg>
    